import axios from 'axios'
import './common'

export default {
    create: (data) => axios.post(`/password-reset`, data),
    verifyCode: (id, data) => axios.patch(`/password-reset/${id}/verify-code`, data),
    resetPassword: (id, data) => axios.patch(`/password-reset/${id}/reset-password`, data)
}